// import * as permissions from '../../utils/permissions'
import * as roles from '../../utils/roles'

export default {
  // permissions,
  roles
}
